// removed by extract-text-webpack-plugin
module.exports = {"card":"_5_LL-apJOd","content":"_2tT3kOO6yY vr vr_x3","title":"_1wQLrMMq1I"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/AccountCardWrapper/AccountCardWrapper.module.less
// module id = 995
// module chunks = 3